export const environment = {
  production: true,
  apiUrl: 'https://roughcheck.com/',
  ERROR_RPIN_REQUIRED: 'error_rpin',
  ERROR_APIN_REQUIRED: 'error_apin',
  ERROR_INACTIVE: 'error_inactive'
};
